<h1 class="mf-popup-title">Nov združen dokument</h1>
<div class="m-portlet mf-portlet-gray__gray-background">
    <div class="m-portlet__body">
        <div class="m-content"></div>
        <div class="m-portlet">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text">Združen dokument</h3>
                    </div>
                </div>
            </div>
            <div class="m-portlet__body">
                <div class="pb-3">
                    <span class="m--font-boldest pr-2">Listina</span>
                    <div class="d-flex align-items-center pl-2">
                        <span class="d-block pdf-icon pr-2">
                            <img src="./assets/app/media/img/files/pdf.svg" alt="" />
                        </span>
                        <span>{{ paper?.paperType | paperName }}</span>
                    </div>
                </div>
                <div class="pb-3">
                    <span class="m--font-boldest pr-2">Dokument</span>
                    <ng-select [items]="documentList$ | async" [multiple]="false" [formControl]="fcSelectedDocument" placeholder="Izberi dokument">
                        <ng-template ng-label-tmp ng-option-tmp let-item="item">
                            <div class="d-flex align-items-center">
                                <span class="d-block pdf-icon pr-2">
                                    <img src="./assets/app/media/img/files/pdf.svg" alt="" />
                                </span>
                                <span class="pr-1">{{ item.description }}</span>
                                <small *ngIf="item?.documentAdded">| ({{ item?.documentAdded | date: 'dd.MM.yyyy' }})</small>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="m-list-search__result-item">
                    <span class="m--font-boldest pr-2">Naziv združenega dokumenta</span>
                    <span class="m-list-search__result-item-text">
                        <input [formControl]="fcFileName" type="text" class="form-control m-input" />
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer mf-custom-footer">
    <button
        (click)="activeModal.close(undefined)"
        type="button"
        style="width: 150px"
        class="ml-auto btn m-btn--pill btn-warning m-btn m-btn--custom"
        i18n="@@cancel"
    >
        Prekliči
    </button>
    <button
        [disabled]="!fcFileName.valid || (isLoading$ | async)"
        (click)="onMergeClick()"
        type="submit"
        style="width: 150px"
        class="mr-auto btn m-btn--pill btn-accent m-btn"
    >
        <ng-container *ngIf="isLoading$ | async; else buttonText">
            <div class="d-flex align-items-center justify-content-center">
                <div class="m-loader m-loader--brand loader-size"></div>
                <span class="pl-2">Nalagam...</span>
            </div>
        </ng-container>
        <ng-template #buttonText><span>Združi</span></ng-template>
    </button>
</div>
